import { useCallback } from 'react'

import { Command } from '@cowprotocol/types'
import { useWeb3React } from '@web3-react/core'

// TODO: Add proper return type annotation
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useDisconnectWallet(onDisconnect?: Command) {
  // TODO M-2 COW-568
  // Wallet connection (and warnings) through wagmi will be handled in a future task
  const { connector } = useWeb3React()

  return useCallback(() => {
    if (connector.deactivate) {
      connector.deactivate()
    } else {
      connector.resetState()
    }

    onDisconnect?.()
  }, [onDisconnect, connector])
}
